import mixinInput from '/@mixins/input'

export default {
  mixins: [mixinInput],
  computed: {
    isChecked: {
      get() {
        return this.value
      },
      set(value) {
        this.emitValue(value)
      },
    },
  },
}
